import { until } from 'until-async'
import type { VKBridge } from '@vkontakte/vk-bridge'
import { getErrorLog } from '../../robowhale/utils/error/utils'
import { Platform } from '../Platform'
import { BasePlatformPreloader } from './BasePlatformPreloader'

/**
 * @link https://dev.vk.com/ru/games/bridge
 */
export class VkPlatformPreloader extends BasePlatformPreloader {
	public readonly type: Platform = 'vk'

	private _initCompleted: Promise<VKBridge> | undefined

	public async loadAndInit(): Promise<VKBridge> {
		if (this._initCompleted) {
			return this._initCompleted
		}

		this._initCompleted = this.initBridge()
		
		return this._initCompleted
	}

	private async initBridge(): Promise<VKBridge> {
		await this.loadScriptWithRetries('https://unpkg.com/@vkontakte/vk-bridge/dist/browser.min.js')

		const bridge = window['vkBridge'] as VKBridge | undefined
		if (!bridge) {
			throw new Error('vkBridge is not available')
		}

		const [error] = await until(() => bridge.send('VKWebAppInit'))

		if (error) {
			throw new Error(getErrorLog(error))
		}

		return bridge
	}
}
